"use strict";

var __extends = this && this.__extends || function () {
  var extendStatics = function (d, b) {
    extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return extendStatics(d, b);
  };
  return function (d, b) {
    extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var react_1 = __importDefault(require("react"));
var PlaceholderCommon_1 = require("./PlaceholderCommon");
var withComponentFactory_1 = require("../enhancers/withComponentFactory");
function isRawRendering(rendering) {
  return !rendering.componentName && rendering.name !== undefined;
}
var PlaceholderComponent = /** @class */function (_super) {
  __extends(PlaceholderComponent, _super);
  function PlaceholderComponent(props) {
    return _super.call(this, props) || this;
  }
  PlaceholderComponent.prototype.render = function () {
    var _this = this;
    var childProps = __assign({}, this.props);
    delete childProps.componentFactory;
    if (this.state.error) {
      if (childProps.errorComponent) {
        return react_1.default.createElement(childProps.errorComponent, {
          error: this.state.error
        });
      }
      return react_1.default.createElement("div", {
        className: "sc-jss-placeholder-error"
      }, "A rendering error occurred: ", this.state.error.message, ".");
    }
    var renderingData = childProps.rendering;
    var placeholderData = PlaceholderCommon_1.PlaceholderCommon.getPlaceholderDataFromRenderingData(renderingData, this.props.name);
    var components = this.getComponentsForRenderingData(placeholderData);
    if (this.props.renderEmpty && placeholderData.every(function (rendering) {
      return isRawRendering(rendering);
    })) {
      return this.props.renderEmpty(components, placeholderData, childProps);
    } else if (this.props.render) {
      return this.props.render(components, placeholderData, childProps);
    } else if (this.props.renderEach) {
      return components.map(function (component, index) {
        if (component && component.props && component.props.type === 'text/sitecore') {
          return component;
        }
        return _this.props.renderEach(component, index);
      });
    } else {
      return components;
    }
  };
  PlaceholderComponent.propTypes = PlaceholderCommon_1.PlaceholderCommon.propTypes;
  return PlaceholderComponent;
}(PlaceholderCommon_1.PlaceholderCommon);
exports.Placeholder = withComponentFactory_1.withComponentFactory(PlaceholderComponent);